import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BuergscheinCreateSuper } from './bgsch-create.super';
import { CreateBuergscheinModel } from '../../../../model.module/create-buergschein.model';

@Component({
    selector: 'bgsch-create-abschl-4',
    templateUrl: './bgsch-create-abschl-4.component.html',
    styleUrls: ['./bgsch-create.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuergschaftCreateComponentAbschl4 extends BuergscheinCreateSuper {

    @Input()
    model: CreateBuergscheinModel = new CreateBuergscheinModel();

    constructor() {
        super();
    }

}
